import React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import Search from "../components/Search";

import ErrorBody from "../components/organisms/Error";

import Footer from "../components/Footer";

class Error extends React.Component {

    constructor(props) {
        super(props);
    }

    render(){
        let site = [],
            M_Search = <Search _Async={ true } key={ "search" } />,
            M_body = <ErrorBody key={ "ErrorBody" } />,
            M_Footer = <Footer _ClassName={'mt0'} key={ "footer" } />;

        site.push( M_Search );
        site.push( M_body );
        site.push( M_Footer );
        return (

            <div className="site">
                { site }
            </div>

        );
    }
}

export default connect(
    state => ({
        _global: state.global
    }),
    dispatch => ({
        global: bindActionCreators( global, dispatch)
    })
)( Error );




// WEBPACK FOOTER //
// ./common/containers/404.js